const translations = {
  'spanishCourse.seo.title': 'Cursos intensivos de español para profesores de TEFL en Barcelona',
  'spanishCourse.seo.description':
    'Cursos de español diseñados para nuevos profesores en Barcelona. Comienza tu español estudiando con nuestros profesores experimentados. ',
};

export default translations;
